export default __webpack_public_path__ + "static/media/home.2558229f.png";